<script lang="ts">
  import type { Component } from 'svelte'
  import type { SerializedBlock, SerializedPreviewImageBlock } from '../../types'
  import HeaderBlock from './HeaderBlock.svelte'
  import ParagraphBlock from './ParagraphBlock.svelte'
  import UnorderedListBlock from './UnorderedListBlock.svelte'
  import OrderedListBlock from './OrderedListBlock.svelte'
  import SeparatorBlock from './SeparatorBlock.svelte'
  import MapBlock from './MapBlock.svelte'
  import MapListBlock from './MapListBlock.svelte'
  import ImageBlock from './ImageBlock.svelte'
  import ImageGalleryBlock from './ImageGalleryBlock.svelte'
  import VideoBlock from './VideoBlock.svelte'
  import VideoGalleryBlock from './VideoGalleryBlock.svelte'
  import DocumentBlock from './DocumentBlock.svelte'
  import TagsBlock from './TagsBlock.svelte'

  // `priority` loads the block's media first, for media at the top of the page.
  let { block, priority = false }: { block: SerializedBlock | SerializedPreviewImageBlock; priority?: boolean } = $props()

  const BLOCK_COMPONENTS: Record<SerializedBlock['type'], Component<any>> = {
    HeaderBlock,
    ParagraphBlock,
    UnorderedListBlock,
    OrderedListBlock,
    SeparatorBlock,
    MapBlock,
    MapListBlock,
    ImageBlock,
    ImageGalleryBlock,
    VideoBlock,
    VideoGalleryBlock,
    DocumentBlock,
    TagsBlock,
  }

  // These blocks lay out their media on the page grid's full column, which their section passes through as a subgrid.
  const BREAKOUT_BLOCK_TYPES: SerializedBlock['type'][] = ['ImageBlock', 'ImageGalleryBlock', 'VideoBlock', 'VideoGalleryBlock']

  const CurrentBlock = $derived(block.type === 'PreviewImageBlock' ? null : BLOCK_COMPONENTS[block.type])
  const breakout = $derived(block.type !== 'PreviewImageBlock' && BREAKOUT_BLOCK_TYPES.includes(block.type))
</script>

{#if CurrentBlock}
  <section class={['block-renderer', { '-breakout': breakout }]}>
    <CurrentBlock {block} {priority} />
  </section>
{/if}

<style>
  /* Grid item of the page's breakout grid (see PagesShow.svelte). */
  .block-renderer {
    grid-column: content;
  }

  /* Passes the page grid through, so the block can place its media on the full column. */
  .block-renderer.-breakout {
    grid-column: full;
    display: grid;
    grid-template-columns: subgrid;
  }
</style>
